<div style="height: 100%; overflow: auto;">
  <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch center; align-items: stretch; padding: 12px 0;">
    <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch flex-start; align-items: stretch; flex: 1 1 100%; width: fit-content; max-width: 50%">
      <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 5%">
      </div>

      <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
        <mat-toolbar color="primary" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
          <div>Case Details</div>
        </mat-toolbar>
        <div *ngIf="caseDetailsForm" style="overflow-y: auto; flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined">
              <mat-card-content>
                <form [formGroup]="caseDetailsForm" novalidate (ngSubmit)="onSubmit()" style="display: flex; flex-direction: column;">

                  <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                    <div style="flex: 1 1 0%; box-sizing: border-box;">
                      <mat-form-field class="full-width">
                        <mat-label>Case Name</mat-label>
                        <input matInput id="caseName" placeholder="Case Name" formControlName="caseName" required />
                         @if (caseDetailsForm.controls['caseName'].invalid && (caseDetailsForm.controls['caseName'].dirty || caseDetailsForm.controls['caseName'].touched)) {
                          <mat-error>
                            <p *ngIf="caseDetailsForm.controls['caseName'].errors.required">Case Name is <strong>required</strong>.</p>
                            <p *ngIf="caseDetailsForm.controls['caseName'].errors.maxlength">Case Name cannot exceed <strong>256</strong> characters.</p>
                          </mat-error>
                         }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                    <div style="flex: 1 1 0%; box-sizing: border-box;">
                      <mat-form-field class="full-width">
                        <mat-label>Case Number</mat-label>
                        <input id="caseNumber" matInput placeholder="Case Number" formControlName="caseNumber" />
                        @if (caseDetailsForm.controls['caseNumber'].invalid && (caseDetailsForm.controls['caseNumber'].dirty || caseDetailsForm.controls['caseNumber'].touched)) {
                          <mat-error *ngIf="caseDetailsForm.controls['caseNumber'].errors.maxlength">
                            Case Number cannot exceed <strong>256</strong> characters.
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div style="flex: 1 1 0%; box-sizing: border-box;">
                      <mat-form-field class="full-width">
                        <mat-label>Case Type</mat-label>
                        <input id="caseType" matInput placeholder="Case Type" formControlName="caseType" />
                        @if (caseDetailsForm.controls['caseType'].invalid && (caseDetailsForm.controls['caseType'].dirty || caseDetailsForm.controls['caseType'].touched)) {
                          <mat-error *ngIf="caseDetailsForm.controls['caseType'].errors.maxlength">
                            Case Type cannot exceed <strong>256</strong> characters.
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                    <div style="flex: 1 1 0%; box-sizing: border-box;">
                      <mat-form-field class="full-width">
                        <mat-label>Venue</mat-label>
                        <input id="caseVenue" matInput placeholder="Venue" formControlName="caseVenue" />
                        @if (caseDetailsForm.controls['caseVenue'].invalid && (caseDetailsForm.controls['caseVenue'].dirty || caseDetailsForm.controls['caseVenue'].touched)) {
                          <mat-error *ngIf="caseDetailsForm.controls['caseVenue'].errors.maxlength">
                            Case Venue cannot exceed <strong>256</strong> characters.
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div style="flex: 1 1 0%; box-sizing: border-box;">
                      <mat-form-field class="full-width">
                        <mat-label>Lead Attorney</mat-label>
                        <input id="leadAttorney" matInput placeholder="Lead Attorney" formControlName="leadAttorney" />
                        @if (caseDetailsForm.controls['leadAttorney'].invalid && (caseDetailsForm.controls['leadAttorney'].dirty || caseDetailsForm.controls['leadAttorney'].touched)) {
                          <mat-error *ngIf="caseDetailsForm.controls['leadAttorney'].errors.maxlength">
                            Lead Attorney cannot exceed <strong>256</strong> characters.
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                    <div style="flex: 1 1 0%; box-sizing: border-box;">
                      <mat-form-field class="full-width">
                        <mat-label>Trier Of Fact</mat-label>
                        <input id="trierOfFact" matInput placeholder="Trier Of Fact" formControlName="trierOfFact" maxLength="1024">
                          @if (caseDetailsForm.controls['trierOfFact'].invalid && (caseDetailsForm.controls['trierOfFact'].dirty || caseDetailsForm.controls['trierOfFact'].touched)) {
                            <mat-error *ngIf="caseDetailsForm.controls['caseVenue'].errors.maxlength">
                              Trier Of Fact cannot exceed <strong>256</strong> characters.
                            </mat-error>
                          }
                      </mat-form-field>
                    </div>
                    <div style="flex: 1 1 0%; box-sizing: border-box;">
                      <mat-form-field class="full-width">
                        <mat-label>Custom Designation</mat-label>
                        <input id="customDesignation" matInput placeholder="Attorneys' Eyes Only" formControlName="customDesignation" />
                          @if (caseDetailsForm.controls['customDesignation'].invalid && (caseDetailsForm.controls['customDesignation'].dirty || caseDetailsForm.controls['customDesignation'].touched)) {
                            <mat-error *ngIf="caseDetailsForm.controls['customDesignation'].errors.maxlength">
                              Custom Designation cannot exceed <strong>256</strong> characters.
                            </mat-error>
                          }
                      </mat-form-field>
                    </div>
                  </div>

                  <div  style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; gap: 20px;" >
                    <div class="expand">
                      <mat-form-field class="full-width">
                        <mat-label>Comments</mat-label>
                        <textarea id="caseComments" matInput placeholder="Comments" formControlName="caseComments"></textarea>
                          @if (caseDetailsForm.controls['caseComments'].invalid && (caseDetailsForm.controls['caseComments'].dirty || caseDetailsForm.controls['caseComments'].touched)) {
                            <mat-error *ngIf="caseDetailsForm.controls['caseComments'].errors.maxlength">
                              Case Comments cannot exceed <strong>1024</strong> characters.
                            </mat-error>
                          }
                      </mat-form-field>
                    </div>
                  </div>

                  <div  style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; gap: 20px;" >
                    <div class="expand">
                      <mat-form-field class="full-width">
                        <mat-label>Keywords</mat-label>
                        <textarea id="caseKeywords" matInput placeholder="Keywords" formControlName="caseKeywords"></textarea>
                        <div *ngIf="caseDetailsForm.controls['caseKeywords'].invalid && (caseDetailsForm.controls['caseKeywords'].dirty || caseDetailsForm.controls['caseKeywords'].touched)">
                        </div>
                      </mat-form-field>
                    </div>
                  </div>

                  <div *ngIf="currentCase.customFields">
                    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column" class="full-width">
                      <div *ngFor="let field of currentCase.customFields" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; padding-bottom: 8px;">
                        <div *ngIf="field.type === 0">
                          <div class="case-details-custom-field-header" style="padding-top:10px; padding-bottom:5px;"> Section: {{field.title}} </div>
                        </div>
                        <div *ngIf="field.type === 1">
                          <mat-form-field class="full-width">
                            <mat-label>{{field.title}}</mat-label>
                            <div *ngIf="field.type === 1">
                              <input matInput [placeholder]="field.title" [formControlName]="field.fieldId" />
                            </div>
                            @if (caseDetailsForm.controls[field.fieldId].invalid && (caseDetailsForm.controls[field.fieldId].dirty || caseDetailsForm.controls[field.fieldId].touched)) {
                              <mat-error *ngIf="caseDetailsForm.controls[field.fieldId].errors.maxlength">
                                <p>This field cannot exceed <strong>256</strong> characters.</p>
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div *ngIf="field.type === 2">
                          <mat-checkbox [formControlName]="field.fieldId">
                            {{field.title}}
                          </mat-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>

                </form>
              </mat-card-content>

              <mat-card-actions>
                <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center;">
                  <button id="update" mat-raised-button color="primary" type="submit" (click)="onSubmit()">Update</button>
                  <button id="cancel" mat-button color="secondary" type="button" (click)="onCancel()">Cancel</button>
                </div>
              </mat-card-actions>

            </mat-card>
        </div>
      </div>

      <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 5%">
      </div>
    </div>
  </div>
</div>
